<template>
  <div class="bg-gray-100 text-xxs">
    <div v-for="item of getFirst().list()" :key="item.id">
      <div
        class="border rounded-full p-1 px-2 flex items-center"
        @click="selectNode(item)"
      >
        <div
          class="w-5 h-5 rounded-full mr-2 hover:bg-red-600 hover:text-white flex"
          @click="deleteNode(item)"
        >
          <XIcon size="14" class="m-auto" />
        </div>
        <div>{{item.localName}}</div>
      </div>
      <Tree :node="item" class="ml-2" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Tree",
  props: {
    node: null
  },
  computed: {
    ...mapGetters(["rootNode"])
  },
  methods: {
    ...mapActions(["selectNode", "deleteNode"]),
    getFirst() {
      return this.node ? this.node : this.rootNode;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
